import { render, staticRenderFns } from "./collapsible-with-items.vue?vue&type=template&id=6000b6d2&scoped=true"
import script from "./collapsible-with-items.vue?vue&type=script&lang=js"
export * from "./collapsible-with-items.vue?vue&type=script&lang=js"
import style0 from "./collapsible-with-items.vue?vue&type=style&index=0&id=6000b6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000b6d2",
  null
  
)

export default component.exports